module.exports = __webpack_public_path__ + "static/img/son1.ba05c36b.png";